export function translate(label, dictionary, locale, useFallback = true) {
    let translatedLabel = label;
    if (!Object.prototype.hasOwnProperty.call(dictionary, label)) {
        if (!useFallback) {
            throw new Error(`Cannot find label '${label}' in translation mapping`);
        }
    }
    else {
        const translationForThisLabel = dictionary[label];
        if (Object.prototype.hasOwnProperty.call(translationForThisLabel, locale)) {
            translatedLabel = translationForThisLabel[locale];
        }
        else if (!useFallback) {
            throw new Error(`Cannot find locale '${locale}' translation for label '${label}' in mapping`);
        }
    }
    return translatedLabel;
}
